/*
 * Support's VM Activation Codes page reads `/v1/licensing/activation-keys` one page at a time
 * (SYN-3456). The server defaults to 20 rows and caps `pageSize` at 200, so the page size list
 * must not offer more. `productKey` is the whole key as typed; blank means no filter and is left
 * out of the query.
 */
export const GET_ACTIVATION_KEYS_DEFAULT_QUERY_PARAMS = {
	page: 1,
	pageSize: 20,
	productKey: ''
};

export const ACTIVATION_KEYS_SIZE_PER_PAGE_LIST = [20, 50, 100, 200];

/*
 * The search box fires on every keystroke. A whole key is nineteen characters; waiting for a pause
 * sends one request for a pasted or typed key instead of one per character.
 */
export const ACTIVATION_KEYS_SEARCH_DEBOUNCE_MS = 300;
